interface TemplateGroupSelectorProps {
  groupNames: string[];
  selectedGroups: string[];
  onToggleGroup: (group: string) => void;
  availableTemplates: Array<{ name: string; groupName?: string }>;
  selectedTemplates: string[];
  onToggleTemplate: (name: string) => void;
  customMode: boolean;
  onToggleMode: () => void;
  loading: boolean;
}

function LoadingState() {
  return (
    <div className="flex items-center justify-center py-4">
      <svg className="animate-spin h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      <span className="ml-2 text-sm text-gray-500 dark:text-gray-400">Carregando...</span>
    </div>
  );
}

function CheckboxItem({ checked, onChange, label, detail }: { checked: boolean; onChange: () => void; label: string; detail?: string }) {
  return (
    <label className="flex items-center gap-2 cursor-pointer hover:bg-gray-50 dark:hover:bg-slate-700 p-2 rounded">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="w-4 h-4 text-blue-600 border-gray-300 dark:border-slate-600 rounded focus:ring-2 focus:ring-blue-500 dark:bg-slate-700"
      />
      <span className="text-sm text-gray-700 dark:text-gray-300">{label}</span>
      {detail && <span className="text-xs text-gray-400">{detail}</span>}
    </label>
  );
}

function GroupList({ groupNames, selectedGroups, onToggleGroup, availableTemplates }: Pick<TemplateGroupSelectorProps, 'groupNames' | 'selectedGroups' | 'onToggleGroup' | 'availableTemplates'>) {
  return (
    <div className="space-y-2">
      {groupNames.map(group => (
        <CheckboxItem
          key={group}
          checked={selectedGroups.includes(group)}
          onChange={() => onToggleGroup(group)}
          label={group}
          detail={`(${availableTemplates.filter(t => t.groupName === group).length} modelos)`}
        />
      ))}
    </div>
  );
}

function TemplateList({ availableTemplates, selectedTemplates, onToggleTemplate }: Pick<TemplateGroupSelectorProps, 'availableTemplates' | 'selectedTemplates' | 'onToggleTemplate'>) {
  if (availableTemplates.length === 0) {
    return <p className="text-sm text-gray-500 dark:text-gray-400">Nenhum template disponível</p>;
  }
  return (
    <div className="space-y-2">
      {availableTemplates.map(template => (
        <CheckboxItem
          key={template.name}
          checked={selectedTemplates.includes(template.name)}
          onChange={() => onToggleTemplate(template.name)}
          label={template.name}
        />
      ))}
    </div>
  );
}

function SelectorContent(props: TemplateGroupSelectorProps) {
  if (props.loading) return <LoadingState />;
  if (!props.customMode) return <GroupList {...props} />;
  return <TemplateList {...props} />;
}

export default function TemplateGroupSelector(props: TemplateGroupSelectorProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          Modelos de Notificação
        </label>
        <button type="button" onClick={props.onToggleMode} className="text-xs text-blue-600 dark:text-blue-400 hover:underline">
          {props.customMode ? 'Selecionar por grupo' : 'Personalizar'}
        </button>
      </div>
      <div className="border border-gray-300 dark:border-slate-600 rounded-lg p-3 max-h-40 overflow-y-auto">
        <SelectorContent {...props} />
      </div>
    </div>
  );
}
